import { useEffect, useRef, useState } from 'react'

/** Elapsed ms while a live stream wait is on screen. Resets when inactive. */
export function useLiveWaitElapsed(active: boolean): number {
  const startedAtRef = useRef<number | null>(null)
  const [elapsedMs, setElapsedMs] = useState(0)

  useEffect(() => {
    if (!active) {
      startedAtRef.current = null
      setElapsedMs(0)
      return
    }
    if (startedAtRef.current == null) {
      startedAtRef.current = Date.now()
    }
    const tick = () => {
      setElapsedMs(Date.now() - (startedAtRef.current ?? Date.now()))
    }
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [active])

  return elapsedMs
}
